/* OGNO:COUNTDOWN_I18N
   The countdown bar and the product page countdown card are rendered by the Algoshop
   app. That app stores one piece of text per campaign and the shop runs as a single
   European market, so the app itself cannot show different wording per language and
   every visitor sees English.

   This file translates the bar after the app has drawn it. It only ever replaces the
   exact English strings listed below, and only inside the app's own containers, so it
   is a no-op if the app changes its copy or its markup. English is left untouched.

   To change the wording, edit STRINGS. To retire this file once the bar is rebuilt in
   the theme or the app gains per-language text, delete the script tag in theme.liquid.
*/
(function () {
  var lang = (document.documentElement.getAttribute('lang') || 'en').slice(0, 2).toLowerCase();
  if (lang === 'en') return;

  var STRINGS = {
    de: {
      'Special offer just for a short time!': 'Nur für kurze Zeit!',
      "Shop now and enjoy exclusive discounts before they're gone.": 'Jetzt shoppen und exklusive Rabatte sichern, solange sie gelten.',
      'Hours': 'Std.', 'Mins': 'Min.', 'Secs': 'Sek.'
    },
    fr: {
      'Special offer just for a short time!': 'Offre spéciale, pour une durée limitée !',
      "Shop now and enjoy exclusive discounts before they're gone.": 'Achetez maintenant et profitez de remises exclusives avant qu’elles ne disparaissent.',
      'Hours': 'Heures', 'Mins': 'Min', 'Secs': 'Sec'
    },
    it: {
      'Special offer just for a short time!': 'Offerta speciale, solo per poco tempo!',
      "Shop now and enjoy exclusive discounts before they're gone.": 'Acquista ora e approfitta di sconti esclusivi prima che finiscano.',
      'Hours': 'Ore', 'Mins': 'Min', 'Secs': 'Sec'
    },
    es: {
      'Special offer just for a short time!': '¡Oferta especial por tiempo limitado!',
      "Shop now and enjoy exclusive discounts before they're gone.": 'Compra ahora y disfruta de descuentos exclusivos antes de que desaparezcan.',
      'Hours': 'Horas', 'Mins': 'Min', 'Secs': 'Seg'
    },
    nl: {
      'Special offer just for a short time!': 'Speciale aanbieding, alleen voor korte tijd!',
      "Shop now and enjoy exclusive discounts before they're gone.": 'Shop nu en profiteer van exclusieve kortingen zolang ze er zijn.',
      'Hours': 'Uur', 'Mins': 'Min', 'Secs': 'Sec'
    }
  };

  var map = STRINGS[lang];
  if (!map) return;

  var SELECTOR = '[id*="algoshop"], [class*="algoshop"], [class*="countdown"], [id*="countdown"]';

  function translateIn(root) {
    if (!root || root.nodeType !== 1) return;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var node;
    while ((node = walker.nextNode())) {
      var key = node.nodeValue.trim();
      if (key && Object.prototype.hasOwnProperty.call(map, key)) {
        node.nodeValue = node.nodeValue.replace(key, map[key]);
      }
    }
  }

  function sweep() {
    var hosts = document.querySelectorAll(SELECTOR);
    for (var i = 0; i < hosts.length; i++) translateIn(hosts[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sweep);
  } else {
    sweep();
  }

  /* the bar is drawn client side and its digits re-render every tenth of a second,
     so watch for it appearing and re-translate, then stop watching after 30 seconds. */
  var observer = new MutationObserver(function (records) {
    for (var i = 0; i < records.length; i++) {
      var added = records[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var n = added[j];
        if (n.nodeType !== 1) continue;
        if (n.matches && n.matches(SELECTOR)) translateIn(n);
        else if (n.querySelector && n.querySelector(SELECTOR)) sweep();
      }
    }
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
  setTimeout(function () { observer.disconnect(); sweep(); }, 30000);
})();
